import React, { useRef, useState } from 'react';

const Footer = () => {
    const formRef = useRef();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus({ type: '', message: '' });

        const formData = new FormData(formRef.current);
        const data = {
            name: formData.get('template-contactform-name'),
            email: formData.get('template-contactform-email'),
            phone: formData.get('template-contactform-phone'),
            message: formData.get('template-contactform-message')
        };

        try {
            const response = await fetch('https://rexrothnutriscience.com/mail/send_email.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    to: 'info@rexrothnutriscience.com',
                    subject: `New Contact Form Submission from ${data.name}`,
                    message: `
                        Name: ${data.name}
                        Email: ${data.email}
                        Phone: ${data.phone}
                        
                        Message:
                        ${data.message}
                    `
                })
            });

            if (response.ok) {
                setSubmitStatus({
                    type: 'success',
                    message: 'Message sent successfully! We will get back to you soon.'
                });
                formRef.current.reset();
            } else {
                throw new Error('Failed to send message');
            }
        } catch (error) {
            console.error('Error sending email:', error);
            setSubmitStatus({
                type: 'error',
                message: 'Failed to send message. Please try again later.'
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div>
            <div className="section dark bg-color my-0" id="contact-form">
                <div className="container">
                    <div className="row align-items-center justify-content-between">
                        <div className="col-md-4 mt-4">
                            <img src="demos/doctors/images/icons/wave.svg" alt="..." className="position-absolute top-0 start-0 translate-middle d-none d-md-block" width="36" />
                            <h3 className="display-6">Get in touch with Us</h3>
                            <p>Ready to explore our products or discuss partnership opportunities? We're here to help.</p>

                            <div className="divider divider-xs fw-light font-body text-uppercase mb-5 op-05 ms-0" style={{ "--cnvs-divider-border-color": "rgba(var(--cnvs-contrast-rgb), 0.2)" }}>
                                <div className="divider-text">Or</div>
                            </div>

                            <h3 className="fs-6 fw-light text-uppercase op-07 mb-2">Give us a Quick Call</h3>
                            <h2 className="display-4">+91 9824239449</h2>
                        </div>

                        <div className="col-md-6">
                            <div className="form-widget">
                                {submitStatus.message && (
                                    <div className={`alert ${submitStatus.type === 'success' ? 'alert-success' : 'alert-danger'} mb-4`}>
                                        {submitStatus.message}
                                    </div>
                                )}
                                <form ref={formRef} className="row mb-0" onSubmit={handleSubmit}>
                                    <div className="form-process">
                                        <div className="css3-spinner">
                                            <div className="css3-spinner-scaler"></div>
                                        </div>
                                    </div>

                                    <div className="col-12 form-group">
                                        <input type="text" id="template-contactform-name" name="template-contactform-name" className="form-control border-form-control border-light border-opacity-50 py-3 required text-white" placeholder="Full Name.." required />
                                    </div>

                                    <div className="col-12 form-group">
                                        <input type="email" id="template-contactform-email" name="template-contactform-email" className="email form-control border-form-control border-light border-opacity-50 py-3 required text-white" placeholder="Email Address.." required />
                                    </div>

                                    <div className="col-12 form-group">
                                        <input type="text" id="template-contactform-phone" name="template-contactform-phone" className="form-control border-form-control border-light border-opacity-50 py-3 text-white" placeholder="Phone Number.." />
                                    </div>

                                    <div className="col-12 form-group">
                                        <textarea className="required form-control border-form-control border-light border-opacity-50 py-3 text-white" id="template-contactform-message" name="template-contactform-message" rows="2" cols="30" placeholder="Type Your Message Here.." required></textarea>
                                    </div>

                                    <div className="col-12 form-group">
                                        <button 
                                            className="button button-large button-light h-text-dark h-bg-color-2 rounded ms-0 mt-3" 
                                            type="submit" 
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? 'Sending...' : 'Send Message'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <footer id="footer" className="bg-color dark border-width-1">
                <div className="container">
                    <div className="footer-widgets-wrap">
                        <div className="row gx-4 gy-5">
                            <div className="col-lg-3 col-6">
                                <div className="widget widget_links widget-li-noicon">
                                    <h4 className="text-uppercase mb-4">Quick Links</h4>
                                    <ul>
                                        <li><a href="/">Home</a></li>
                                        <li><a href="/global-presence">Global Presence</a></li>
                                        <li><a href="/blogs">Blogs</a></li>
                                        <li><a href="tel:+919824239449">Contact</a></li>
                                    </ul>
                                </div>
                            </div>

                            <div className="col-lg-3 col-6">
                                <div className="widget widget_links widget-li-noicon">
                                    <h4 className="text-uppercase mb-4">Products</h4>
                                    <ul>
                                        <li><a href="/dietary-supplements">Dietary Supplements</a></li>
                                        <li><a href="/fitness-supplements-tablets">Fitness Supplements</a></li>
                                        <li><a href="/healthcare-protein-supplements">Healthcare Products</a></li>
                                        <li><a href="/herbals">Herbal Products</a></li>
                                    </ul>
                                </div>
                            </div>

                            <div className="col-lg-3 col-sm-6">
                                <div className="widget widget_links widget-li-noicon">
                                    <h4 className="text-uppercase mb-4">Resources</h4>
                                    <ul>
                                        <li><a href="/the-rise-of-nutraceuticals">The Rise of Nutraceuticals</a></li>
                                        <li><a href="/the-benefits-of-nutraceuticals">The Benefits of Nutraceuticals</a></li>
                                        <li><a href="/the-importance-of-nutraceuticals">The Importance of Nutraceuticals</a></li>
                                        <li><a href="/the-future-of-nutraceuticals">The Future of Nutraceuticals</a></li>
                                    </ul>
                                </div>
                            </div>

                            <div className="col-lg-3 col-sm-6">
                                <div className="widget">
                                    <h4 className="text-uppercase mb-4">Contact Us</h4>
                                    <ul className="list-unstyled">
                                        <li className="mb-3">
                                            <a href="tel:+919824239449" className="d-flex">
                                                <i className="me-3 bi-telephone-fill"></i>+91 9824239449
                                            </a>
                                        </li>
                                        <li className="mb-3">
                                            <a href="mailto:info@rexrothnutriscience.com" className="d-flex">
                                                <i className="me-3 bi-envelope-fill"></i>info@rexrothnutriscience.com
                                            </a>
                                        </li>
                                        <li className="mb-3">
                                            <a href="#" className="d-flex">
                                                <i className="me-3 bi-geo-alt-fill"></i>Rexroth Nutriscience Pvt. Ltd.
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="copyrights" className="bg-transparent border-top op-08">
                    <div className="container">
                        <div className="row justify-content-md-between">
                            <div className="col-md-auto">
                                Copyrights &copy; 2025 All Rights Reserved by Rexroth Nutriscience Pvt. Ltd.
                            </div>
                            <div className="col-md-auto">
                                Designed and Developed by <a href="https://infikeytech.com" target="_blank" className="text-white text-decoration-none">Infikey Technologies Private Limited</a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Footer; 